import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useRef, forwardRef } from "react";
import { $ as $458b0a5536c1a7cf$export$40bfa8c7b0832715, a as $e5be200c675c3b3a$export$fc1a364ae1f3ff10, b as $e5be200c675c3b3a$export$75ee7c75d68f5b0e } from "../../../../chunks/useFormValidationState-CYjUuzK3.js";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import { Text } from "../../../../foundations/typography/Text/Text.js";
import { CheckboxGroupContext } from "../unstyled/CheckboxBase/hooks/useCheckboxContext.js";
import { h as helpers } from "../../../../chunks/helpers.module-CuLQagYQ.js";
import { $ as $1ae600c947479353$export$ec98120685d4f57d } from "../../../../chunks/utils-nR0dJhWL.js";
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from "../../../../chunks/mergeProps-bpc4gVdj.js";
import { $ as $65484d02dcb7eb3e$export$457c3d6518dd4c6f } from "../../../../chunks/filterDOMProps-D2C6R0DK.js";
import { $ as $2baaea4c71418dea$export$294aa081a6c6f55d } from "../../../../chunks/useField-hKk7NfY9.js";
import { $ as $9ab94262bd0047c7$export$420e68273165f4ec } from "../../../../chunks/useFocusWithin-B_P4x9Es.js";
function $1e9fce0cfacc738b$export$49ff6f28c54f1cbe(props, state) {
  let { isDisabled, name, form, validationBehavior = "aria" } = props;
  let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
  let { labelProps, fieldProps, descriptionProps, errorMessageProps } = $2baaea4c71418dea$export$294aa081a6c6f55d({
    ...props,
    // Checkbox group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid,
    errorMessage: props.errorMessage || validationErrors
  });
  $1ae600c947479353$export$ec98120685d4f57d.set(state, {
    name,
    form,
    descriptionId: descriptionProps.id,
    errorMessageId: errorMessageProps.id,
    validationBehavior
  });
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let { focusWithinProps } = $9ab94262bd0047c7$export$420e68273165f4ec({
    onBlurWithin: props.onBlur,
    onFocusWithin: props.onFocus,
    onFocusWithinChange: props.onFocusChange
  });
  return {
    groupProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      role: "group",
      "aria-disabled": isDisabled || void 0,
      ...fieldProps,
      ...focusWithinProps
    }),
    labelProps,
    descriptionProps,
    errorMessageProps,
    isInvalid,
    validationErrors,
    validationDetails
  };
}
function $587d3ad58be6d31f$export$daff6da51032a415(props = {}) {
  let [selectedValues, setValue] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, props.defaultValue || [], props.onChange);
  let [initialValues] = useState(selectedValues);
  let isRequired = !!props.isRequired && selectedValues.length === 0;
  let invalidValues = useRef(/* @__PURE__ */ new Map());
  let validation = $e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...props,
    value: selectedValues
  });
  let isInvalid = validation.displayValidation.isInvalid;
  var _props_defaultValue, _props_validationState;
  const state = {
    ...validation,
    value: selectedValues,
    defaultValue: (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : initialValues,
    setValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      setValue(value);
    },
    isDisabled: props.isDisabled || false,
    isReadOnly: props.isReadOnly || false,
    isSelected(value) {
      return selectedValues.includes(value);
    },
    addValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (!selectedValues.includes(value)) {
        selectedValues = selectedValues.concat(value);
        setValue(selectedValues);
      }
    },
    removeValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue) => existingValue !== value));
    },
    toggleValue(value) {
      if (props.isReadOnly || props.isDisabled) return;
      if (selectedValues.includes(value)) setValue(selectedValues.filter((existingValue) => existingValue !== value));
      else setValue(selectedValues.concat(value));
    },
    setInvalid(value, v) {
      let s = new Map(invalidValues.current);
      if (v.isInvalid) s.set(value, v);
      else s.delete(value);
      invalidValues.current = s;
      validation.updateValidation($e5be200c675c3b3a$export$75ee7c75d68f5b0e(...s.values()));
    },
    validationState: (_props_validationState = props.validationState) !== null && _props_validationState !== void 0 ? _props_validationState : isInvalid ? "invalid" : null,
    isInvalid,
    isRequired
  };
  return state;
}
const CheckboxGroup = forwardRef(
  ({
    children,
    style,
    className,
    showLabel = true,
    labelVariant = "text-body-head",
    labelComponent = "h3",
    labelClassName,
    ...props
  }, ref) => {
    let state = $587d3ad58be6d31f$export$daff6da51032a415(props);
    let { groupProps, labelProps } = $1e9fce0cfacc738b$export$49ff6f28c54f1cbe(props, state);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ...groupProps,
        ref,
        style,
        className: clsx(groupProps.className, className),
        children: [
          /* @__PURE__ */ jsx(
            Text,
            {
              ...labelProps,
              className: clsx(labelProps.className, !showLabel && helpers.srOnly, labelClassName),
              variant: labelVariant,
              component: labelComponent,
              children: props.label
            }
          ),
          /* @__PURE__ */ jsx(
            CheckboxGroupContext.Provider,
            {
              value: {
                state
              },
              children
            }
          )
        ]
      }
    );
  }
);
export {
  CheckboxGroup
};
